/* eslint-disable jsx-a11y/anchor-is-valid */


// import React, { useState } from "react";
// import { FloatingWhatsApp } from "react-floating-whatsapp";
// import { Link } from "react-router-dom";
// import logo from '../admin/assets/logo2.jpg'

// const MedtrustHeader = () => {
//     const [isSearchOpen, setIsSearchOpen] = useState(false);
//     const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
//     const [openDropdown, setOpenDropdown] = useState(null);
//     const [openSubDropdown, setOpenSubDropdown] = useState({});

//     const handleToggle = (index) => {
//         setOpenDropdown(openDropdown === index ? null : index);
//     };

//     const handleSubToggle = (parentIndex, index) => {
//         setOpenSubDropdown({
//             ...openSubDropdown,
//             [parentIndex]: openSubDropdown[parentIndex] === index ? null : index
//         });
//     };



//     const handleSearchOpen = () => {
//         setIsSearchOpen(true);
//     };

//     const handleSearchClose = () => {
//         setIsSearchOpen(false);
//     };

//     const handleOffcanvasOpen = () => {
//         setIsOffcanvasOpen(true);
//     };

//     const handleOffcanvasClose = () => {
//         setIsOffcanvasOpen(false);
//     };

//     return (
//         <>
//             {/* Mobile Offcanvas Menu */}
//             {isOffcanvasOpen && (
//                 <div className="fix" data-bs-interval="1000">
//                     <div className="offcanvas__area info-close info-open">
//                         <div className="offcanvas__wrapper">
//                             <div className="offcanvas__content">
//                                 <div className="offcanvas__top d-flex justify-content-between align-items-center">
//                                     <div className="offcanvas__logo">
//                                         <Link to="/">
//                                             <img src={logo} style={{ width: '220px' }} alt="logo" />
//                                         </Link>
//                                     </div>
//                                     <div className="offcanvas__close">
//                                         <button className="offcanvas-close-icon animation--flip" onClick={handleOffcanvasClose}>
//                                             <span className="offcanvas-m-lines">
//                                                 <span className="offcanvas-m-line line--1"></span>
//                                                 <span className="offcanvas-m-line line--2"></span>
//                                                 <span className="offcanvas-m-line line--3"></span>
//                                             </span>
//                                         </button>
//                                     </div>
//                                 </div>
//                                 <div className="mobile-menu fix mean-container">
//                                     <div className="mean-bar">
//                                         <nav className="mean-nav">
//                                             <ul>
//                                                 <li><Link to="/">Home</Link></li>
//                                                 <li><Link to="/Medtrust-about">About Us</Link></li>
//                                                 <li><Link to="/medtrust-treatment">Treatments</Link></li>

//                                                 <li className="has-dropdown">
//                                                     <Link to="" onClick={() => handleToggle(1)}>Stories</Link>
//                                                     <a className="mean-expand" href="#" style={{ fontSize: "18px" }} onClick={() => handleToggle(3)}>
//                                                         <i className={`fa-regular fa-angle-right ${openDropdown === 3 ? 'open' : ''}`}></i>
//                                                     </a>
//                                                     <ul className="submenu" style={{ display: openDropdown === 3 ? 'block' : 'none' }}>
//                                                         <li><Link to="/medtrust-patient">Patient Stories</Link></li>
//                                                         <li><Link to="/acronyms-abbreviations">Hospital Stories</Link></li>
                                                    
//                                                     </ul>
//                                                 </li>



                                               
//                                                     {/* <li><Link to="/medtrust-patient">Stories</Link></li> */}
                                               
//                                                 <li><Link to="">Partner Hospitals</Link></li>
//                                                 <li><Link to="/medtrust-appointment">Free Consultations</Link></li>
//                                                 <li><Link to="/blog">Blogs</Link></li>
//                                             </ul>
//                                         </nav>
//                                     </div>
//                                 </div>
//                                 <div className="offcanvas__social">
//                                     <h4 className="offcanvas__title mb-20">Subscribe & Follow</h4>
//                                     <p className="mb-30">Medical practices evolved over millennia, from ancient civilizations like Egypt and Mesopotamia to the groundbreaking</p>
//                                     <ul className="header-top-socail-menu d-flex">
//                                         <li><a href="https://www.facebook.com/"><i className="fab fa-facebook-f"></i></a></li>
//                                         <li><a href="https://twitter.com/"><i className="fab fa-twitter"></i></a></li>
//                                         <li><a href="https://www.pinterest.com/"><i className="fab fa-pinterest-p"></i></a></li>
//                                         <li><a href="https://vimeo.com/"><i className="fab fa-vimeo-v"></i></a></li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="offcanvas__overlay overlay-open" onClick={handleOffcanvasClose}></div>
//                 </div>
//             )}

//             {/* Search Popup */}
//             {isSearchOpen && (
//                 <div className="search__popup">
//                     <div className="container">
//                         <div className="row gx-30">
//                             <div className="col-xxl-12">
//                                 <div className="search__wrapper">
//                                     <div className="search__top d-flex justify-content-between align-items-center">
//                                         <div className="search__logo">
//                                             <Link to="/">
//                                                 <img src={logo} alt="logo" style={{ maxWidth: '150px' }} />
//                                             </Link>
//                                         </div>
//                                         <div className="search__close">
//                                             <button
//                                                 type="button"
//                                                 className="search__close-btn search-close-btn"
//                                                 onClick={handleSearchClose}
//                                             >
//                                                 <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
//                                                     <path
//                                                         d="M17 1L1 17"
//                                                         stroke="currentColor"
//                                                         strokeWidth="1.5"
//                                                         strokeLinecap="round"
//                                                         strokeLinejoin="round"
//                                                     />
//                                                     <path
//                                                         d="M1 1L17 17"
//                                                         stroke="currentColor"
//                                                         strokeWidth="1.5"
//                                                         strokeLinecap="round"
//                                                         strokeLinejoin="round"
//                                                     />
//                                                 </svg>
//                                             </button>
//                                         </div>
//                                     </div>
//                                     <div className="search__form">
//                                         <form action="#">
//                                             <div className="search__input">
//                                                 <input
//                                                     className="search-input-field"
//                                                     type="text"
//                                                     placeholder="Type here to search..."
//                                                 />
//                                                 <span className="search-focus-border"></span>
//                                                 <button type="submit">
//                                                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//                                                         <path
//                                                             d="M9.55 18.1C14.272 18.1 18.1 14.272 18.1 9.55C18.1 4.82797 14.272 1 9.55 1C4.82797 1 1 4.82797 1 9.55C1 14.272 4.82797 18.1 9.55 18.1Z"
//                                                             stroke="currentColor"
//                                                             strokeWidth="1.5"
//                                                             strokeLinecap="round"
//                                                             strokeLinejoin="round"
//                                                         />
//                                                         <path
//                                                             d="M19.0002 19.0002L17.2002 17.2002"
//                                                             stroke="currentColor"
//                                                             strokeWidth="1.5"
//                                                             strokeLinecap="round"
//                                                             strokeLinejoin="round"
//                                                         />
//                                                     </svg>
//                                                 </button>
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Header */}
//             <header>
//                 <div id="header-sticky" className="header__area header-2">
//                     <div className="container">
//                         <div className="mega__menu-wrapper p-relative">
//                             <div className="header__main">
//                                 <div className="header__left d-flex align-items-center">
//                                     <div className="header__logo">
//                                         <Link to="/">
//                                             <div className="logo">
//                                                 <img src={logo} alt="logo" style={{ maxWidth: '200px' }} />
//                                             </div>
//                                         </Link>
//                                     </div>

//                                     {/* Desktop Menu */}
//                                     <div className="mean__menu-wrapper d-none d-xl-block">
//                                         <div className="main-menu main-menu-2">
//                                             <nav id="mobile-menu">
//                                                 <ul>
//                                                     <li><Link to="/">Home</Link></li>
//                                                     <li><Link to="/Medtrust-about">About Us</Link></li>
//                                                     <li><Link to="/medtrust-treatment">Treatments</Link></li>
//                                                      <li className="has-dropdown">
//                                                     <Link to="" onClick={() => handleToggle(1)}>Stories</Link>
//                                                     <a className="mean-expand" href="#" style={{ fontSize: "18px" }} onClick={() => handleToggle(1)}>
//                                                         <i className={`fa-regular fa-angle-right ${openDropdown === 1 ? 'open' : ''}`}></i>
//                                                     </a>
//                                                     <ul className="submenu" style={{ display: openDropdown === 1 ? 'block' : 'none' }}>
//                                                         <li><Link to="/medtrust-patient">Patient Stories</Link></li>
//                                                         <li><Link to="/acronyms-abbreviations">Hospital Stories</Link></li>
                                                    
//                                                     </ul>
//                                                 </li>
//                                                     <li><Link to="">Partner Hospitals</Link></li>
//                                                     <li><Link to="/medtrust-appointment">Free Consultations</Link></li>
//                                                     <li><Link to="/blog">Blogs</Link></li>
//                                                 </ul>
//                                             </nav>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="header__right">
//                                     <div className="header__action d-flex align-items-center">
//                                         <div className="header__btn-wrap align-items-center d-inline-flex">
//                                             <div className="rr-header-icon-search">
//                                                 <button className="search-open-btn" onClick={handleSearchOpen}>
//                                                     <i className="fa-solid fa-magnifying-glass"></i>
//                                                 </button>
//                                             </div>

//                                             <Link to="/contact-us" className="rr-header-message d-none d-sm-block">
//                                                 <i className="fa-regular fa-message"></i>
//                                             </Link>

//                                             <div className="rr-header-contact-btn d-flex align-items-center d-none d-lg-flex">
//                                                 <div className="rr-header-contact-btn__icon">
//                                                     <i className="fa-solid fa-phone"></i>
//                                                 </div>
//                                                 <div className="rr-header-contact-btn__text">
//                                                     <p className="mb-0 color-white">Need help?</p>
//                                                     <h5 className="mb-0 color-white">
//                                                         <a href="tel:+8619811976744">(+86) 19811976744</a>
//                                                     </h5>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Mobile Menu Toggle */}
//                                         <div className="header__hamburger ml-30 mr-10 d-xl-none">
//                                             <div className="sidebar__toggle">
//                                                 <a className="bar-icon" href="javascript:void(0)" onClick={handleOffcanvasOpen}>
//                                                     <span></span>
//                                                     <span></span>
//                                                     <span></span>
//                                                 </a>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </header>

//             {/* WhatsApp Float Button */}
//             <FloatingWhatsApp
//                 phoneNumber="+8619811976744"
//                 accountName="Square Med Tech"
//                 avatar="https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250"
//                 chatMessage="Hi! How can we help you?"
//             />
//         </>
//     );
// };

// export default MedtrustHeader;



import React, { useState, useEffect, useRef } from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { Link } from "react-router-dom";
import logo from '../admin/assets/logo2.jpg'

const MedtrustHeader = () => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
    const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
    const [isDesktopDropdownOpen, setIsDesktopDropdownOpen] = useState(false);
    const desktopDropdownRef = useRef(null);

    // Close desktop dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (desktopDropdownRef.current && !desktopDropdownRef.current.contains(e.target)) {
                setIsDesktopDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleMobileToggle = (index) => {
        setOpenMobileDropdown(openMobileDropdown === index ? null : index);
    };

    const handleSearchOpen = () => setIsSearchOpen(true);
    const handleSearchClose = () => setIsSearchOpen(false);
    const handleOffcanvasOpen = () => setIsOffcanvasOpen(true);
    const handleOffcanvasClose = () => setIsOffcanvasOpen(false);

    return (
        <>
            {/* Mobile Offcanvas Menu */}
            {isOffcanvasOpen && (
                <div className="fix" data-bs-interval="1000">
                    <div className="offcanvas__area info-close info-open">
                        <div className="offcanvas__wrapper">
                            <div className="offcanvas__content">
                                <div className="offcanvas__top d-flex justify-content-between align-items-center">
                                    <div className="offcanvas__logo">
                                        <Link to="/">
                                            <img src={logo} style={{ width: '220px' }} alt="logo" />
                                        </Link>
                                    </div>
                                    <div className="offcanvas__close">
                                        <button className="offcanvas-close-icon animation--flip" onClick={handleOffcanvasClose}>
                                            <span className="offcanvas-m-lines">
                                                <span className="offcanvas-m-line line--1"></span>
                                                <span className="offcanvas-m-line line--2"></span>
                                                <span className="offcanvas-m-line line--3"></span>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div className="mobile-menu fix mean-container">
                                    <div className="mean-bar">
                                        <nav className="mean-nav">
                                            <ul>
                                                <li><Link to="/" onClick={handleOffcanvasClose}>Home</Link></li>
                                                <li><Link to="/Medtrust-about" onClick={handleOffcanvasClose}>About Us</Link></li>
                                                <li><Link to="/medtrust-treatment" onClick={handleOffcanvasClose}>Treatments</Link></li>

                                                {/* Mobile Stories Dropdown */}
                                                <li className="has-dropdown">
                                                    <Link to="#" onClick={(e) => { e.preventDefault(); handleMobileToggle(1); }}>
                                                        Stories
                                                    </Link>
                                                    <a
                                                        className="mean-expand"
                                                        href="#"
                                                        style={{ fontSize: "18px" }}
                                                        onClick={(e) => { e.preventDefault(); handleMobileToggle(1); }}
                                                    >
                                                        <i className={`fa-regular fa-angle-${openMobileDropdown === 1 ? 'down' : 'right'}`}></i>
                                                    </a>
                                                    <ul className="submenu" style={{ display: openMobileDropdown === 1 ? 'block' : 'none' }}>
                                                        <li><Link to="/medtrust-patient" onClick={handleOffcanvasClose}>Patient Stories</Link></li>
                                                        <li><Link to="/medtrust-HospitalStories" onClick={handleOffcanvasClose}>Hospital Stories</Link></li>
                                                    </ul>
                                                </li>

                                                <li><Link to="/medtrust-PartnerHospital" onClick={handleOffcanvasClose}>Partner Hospitals</Link></li>
                                                <li><Link to="/medtrust-appointment" onClick={handleOffcanvasClose}>Free Consultations</Link></li>
                                                <li><Link to="/blog" onClick={handleOffcanvasClose}>Blogs</Link></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>

                                <div className="offcanvas__social">
                                    <h4 className="offcanvas__title mb-20">Subscribe & Follow</h4>
                                    <p className="mb-30">Medical practices evolved over millennia, from ancient civilizations like Egypt and Mesopotamia to the groundbreaking</p>
                                    <ul className="header-top-socail-menu d-flex">
                                        <li><a href="https://www.facebook.com/"><i className="fab fa-facebook-f"></i></a></li>
                                        <li><a href="https://twitter.com/"><i className="fab fa-twitter"></i></a></li>
                                        <li><a href="https://www.pinterest.com/"><i className="fab fa-pinterest-p"></i></a></li>
                                        <li><a href="https://vimeo.com/"><i className="fab fa-vimeo-v"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="offcanvas__overlay overlay-open" onClick={handleOffcanvasClose}></div>
                </div>
            )}

            {/* Search Popup */}
            {isSearchOpen && (
                <div className="search__popup">
                    <div className="container">
                        <div className="row gx-30">
                            <div className="col-xxl-12">
                                <div className="search__wrapper">
                                    <div className="search__top d-flex justify-content-between align-items-center">
                                        <div className="search__logo">
                                            <Link to="/">
                                                <img src={logo} alt="logo" style={{ maxWidth: '150px' }} />
                                            </Link>
                                        </div>
                                        <div className="search__close">
                                            <button
                                                type="button"
                                                className="search__close-btn search-close-btn"
                                                onClick={handleSearchClose}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                    <path d="M17 1L1 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M1 1L17 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="search__form">
                                        <form action="#">
                                            <div className="search__input">
                                                <input
                                                    className="search-input-field"
                                                    type="text"
                                                    placeholder="Type here to search..."
                                                />
                                                <span className="search-focus-border"></span>
                                                <button type="submit">
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M9.55 18.1C14.272 18.1 18.1 14.272 18.1 9.55C18.1 4.82797 14.272 1 9.55 1C4.82797 1 1 4.82797 1 9.55C1 14.272 4.82797 18.1 9.55 18.1Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M19.0002 19.0002L17.2002 17.2002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Header */}
            <header>
                <div id="header-sticky" className="header__area header-2">
                    <div className="container">
                        <div className="mega__menu-wrapper p-relative">
                            <div className="header__main">
                                <div className="header__left d-flex align-items-center">
                                    <div className="header__logo">
                                        <Link to="/">
                                            <div className="logo">
                                                <img src={logo} alt="logo" style={{ maxWidth: '200px' }} />
                                            </div>
                                        </Link>
                                    </div>

                                    {/* Desktop Menu */}
                                    <div className="mean__menu-wrapper d-none d-xl-block">
                                        <div className="main-menu main-menu-2">
                                            <nav id="mobile-menu">
                                                <ul>
                                                    <li><Link to="/">Home</Link></li>
                                                    <li><Link to="/Medtrust-about">About Us</Link></li>
                                                    <li><Link to="/medtrust-treatment">Treatments</Link></li>

                                                    {/* Desktop Stories Dropdown — hover-based via CSS, click as fallback */}
                                                    <li
                                                        className="has-dropdown"
                                                        ref={desktopDropdownRef}
                                                        onMouseEnter={() => setIsDesktopDropdownOpen(true)}
                                                        onMouseLeave={() => setIsDesktopDropdownOpen(false)}
                                                        style={{ position: 'relative' }}
                                                    >
                                                        <Link
                                                            to="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setIsDesktopDropdownOpen(prev => !prev);
                                                            }}
                                                        >
                                                            Stories 
                                                        </Link>
                                                        <ul
                                                            className="submenu"
                                                            style={{
                                                                display: isDesktopDropdownOpen ? 'block' : 'none',
                                                                position: 'absolute',
                                                                top: '85%',
                                                                left: 0,
                                                                zIndex: 999,
                                                                minWidth: '180px',
                                                            }}
                                                        >
                                                            <li>
                                                                <Link to="/medtrust-patient" onClick={() => setIsDesktopDropdownOpen(false)}>
                                                                    Patient Stories
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="/medtrust-HospitalStories" onClick={() => setIsDesktopDropdownOpen(false)}>
                                                                    Hospital Stories
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </li>

                                                    <li><Link to="/medtrust-PartnerHospital">Partner Hospitals</Link></li>
                                                    <li><Link to="/medtrust-appointment">Free Consultations</Link></li>
                                                    <li><Link to="/blog">Blogs</Link></li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>

                                <div className="header__right">
                                    <div className="header__action d-flex align-items-center">
                                        <div className="header__btn-wrap align-items-center d-inline-flex">
                                            <div className="rr-header-icon-search">
                                                <button className="search-open-btn" onClick={handleSearchOpen}>
                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                </button>
                                            </div>

                                            <Link to="/contact-us" className="rr-header-message d-none d-sm-block">
                                                <i className="fa-regular fa-message"></i>
                                            </Link>

                                            <div className="rr-header-contact-btn d-flex align-items-center d-none d-lg-flex">
                                                <div className="rr-header-contact-btn__icon">
                                                    <i className="fa-solid fa-phone"></i>
                                                </div>
                                                <div className="rr-header-contact-btn__text">
                                                    <p className="mb-0 color-white">Need help?</p>
                                                    <h5 className="mb-0 color-white">
                                                        <a href="tel:+8619811976744">(+86) 19811976744</a>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Mobile Menu Toggle */}
                                        <div className="header__hamburger ml-30 mr-10 d-xl-none">
                                            <div className="sidebar__toggle">
                                                <a className="bar-icon" href="javascript:void(0)" onClick={handleOffcanvasOpen}>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* WhatsApp Float Button */}
            <FloatingWhatsApp
                phoneNumber="+8619811976744"
                accountName="Square Med Tech"
                avatar="https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250"
                chatMessage="Hi! How can we help you?"
            />
        </>
    );
};

export default MedtrustHeader;
